export default class KontaktOptionsService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listKontaktOptions");
  }

  save(item){
    return this.server("saveKontaktOption", {nazov: item});
  }

  update(item){
    return this.server("saveKontaktOption", item);
  }

  remove(item){
    return this.server("removeKontaktOption", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/KontaktOptionsService.js